import {Component, DestroyRef, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {CreateClientInitPayload} from '../clients/clients.component';
import {Subject, takeUntil} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CurrentCrudSelectBehaviorServiceAsString, SnackBarService} from '../objectPassingService';
import {Router} from '@angular/router';
import {ClientService} from '../clients/client.service';

function isCreateClientInitPayload(obj: any): obj is CreateClientInitPayload {
  return (
    obj &&
    typeof obj === 'object' &&
    obj.is_edit === false &&
    Object.keys(obj).length === 1
  );
}



// function isGetAllClientPayloadModel(obj: any): obj is GetAllClientPayloadModel {
//   /*
//   The reason we kept both isCreateAdInitPayload() and isGetAllAdPayloadModel() was:
// 	•	To future-proof (in case is_edit accidentally shows up in GetAllAdPayloadModel)
// 	•	To keep the checks isolated and testable
// 	•	To avoid assumptions in the “else” branch
//    */
//   return obj && typeof obj === 'object' && typeof obj.name === 'string';
// }


@Component({
  selector: 'app-clients-meta',
  imports: [],
  templateUrl: './clients-meta.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './clients-meta.component.css'
})
export class ClientsMetaComponent implements OnInit, OnDestroy {

  private destroyRef = inject(DestroyRef);
  destroyed = new Subject<void>();

  is_edit = false;
  is_form_error: boolean = false;
  form_error_message: string = "";
  myForm!: FormGroup;
  title_text = "Create Adgroup";
  submit_text = "Create"


  client_id: number = 0
  client_slug: string = '';
  is_loading = true;


  constructor(
    private fb: FormBuilder,
    private snackBarService: SnackBarService,
    public router: Router, //all components need this
    private currentCrudSelectBehaviorService: CurrentCrudSelectBehaviorServiceAsString,
    private clientService: ClientService,
  ) {
    // Constructor logic here
  } // End of constructor

  ngOnInit() {
  }


  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  } // end ngOnDestroy

  // setForm(data?: GetAllClientPayloadModel) {
  //
  //   if (!data) {
  //
  //     this.myForm = new FormGroup({
  //       name: new FormControl('', [Validators.required])
  //     });
  //
  //   } else {
  //     this.submit_text = "Edit"
  //     this.myForm = this.fb.group({
  //       name: [data.name]
  //     });
  //   }
  //
  //   this.is_loading = false
  // } // setForm



  backToClients() {
    localStorage.removeItem('clientsaved')
    //this.router.navigate(['/nav-campaigns', {outlets: {admeta: ['ads']}}]);
    this.router.navigate(['/nav-campaigns',  { outlets: { admeta: ['clients'] } }]).then(r => console.log('redirect to clients'));
  } // end backToClients

  onFocus(){
    console.log('onFocus')
    this.is_form_error = false;
    this.form_error_message = "";
  } // end onFocus

  onSubmit(){

    this.is_loading = true;
    let form_data = this.myForm.value;
    form_data['client_id'] =  this.client_id  //Math.floor(parseInt(form_data['client_id'], 10));
    console.log(form_data)

    if (!this.is_edit) {

      this.clientService.post(`adserver/adgroup/create`, form_data).pipe(takeUntil(this.destroyed)).subscribe(x => {
        this.snackBarService.announceSackBar('AdGroup Created');
        this.is_loading = false;
        this.backToClients();
      }, error => {
        console.log('error',error)

      });

    } else {

      // console.log('we are editing')
      // let endpoint = `adserver/campaign/${this.campaign_id}`;
      // console.log('endpoint',endpoint)
      // this.campaignService.put(endpoint, form_data).subscribe(x => {
      //   //this.snackBarService.announceSackBar('Client Updated');
      //   this.dialogRef.close(form_data);
      // }, error => {
      //   console.log('error',error)
      //   this.dialogRef.close('cancel');
      // });
    } //end if

  } // end OnSubmit

} // End of ClientsMetaComponent
